import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserModel } from '@libs/account/models';
import { FlashMessageModule, FlashMessageService, SpinnerOverlayService } from '@libs/shared/common';
import { UserService } from '@libs/shared/services';
import { TrackingGoogleService } from '@libs/shared/tracking';
import { firstValueFrom, Observable } from 'rxjs';
import { UserDataComponent } from './data';
import { UserPasswordComponent } from './password';

@Component({
  selector: 'ui-account-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AsyncPipe,
    FlashMessageModule,
    UserDataComponent,
    UserPasswordComponent,
  ],
})
export class UserComponent implements OnInit {
  private readonly userService: UserService = inject(UserService);
  private readonly trackingService: TrackingGoogleService = inject(TrackingGoogleService);
  private readonly flashMessage: FlashMessageService = inject(FlashMessageService);
  private readonly spinnerOverlay: SpinnerOverlayService = inject(SpinnerOverlayService);

  public changePasswordUrl$!: Observable<string | undefined>;
  public user$!: Observable<UserModel | undefined>;

  public ngOnInit(): void {
    if (!this.userService.userLoaded()) {
      this.spinnerOverlay.showLoader();
      void this.userService.loadUser()
        .finally(() => void this.spinnerOverlay.hideLoader());
    }

    if (!this.userService.passwordChangeUrlLoaded()) {
      void this.userService.loadPasswordUrl();
    }

    this.trackingService.trackAccountEvent('benutzerdaten', 'section-auswahl');
    this.user$ = this.userService.getUser();
    this.changePasswordUrl$ = this.userService.getPasswordChangeUrl();
  }

  public onUserDataSubmit(values: Partial<UserModel>): void {
    this.trackingService.trackAccountEvent('benutzerdaten', 'benutzerdaten-speichern');
    this.spinnerOverlay.showLoader();

    firstValueFrom(this.userService.editUser(values))
      .then(() => void this.flashMessage.showMessage('successUserDataUpdate'))
      .catch(() => void this.flashMessage.showMessage('errorUserDataUpdate'))
      .finally(() => void this.spinnerOverlay.hideLoader());
  }

  public onUserPasswordChangeClicked(): void {
    this.trackingService.trackAccountEvent('benutzerdaten', 'pw-aendern');
  }
}
